import { useCallback } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { setMapViewDialogOpen } from '@user/store/map'
import { UseData } from './useData'
import { ENTITY_TYPES } from '@sales-center/common'
import { logger } from '@user/utils/logger'

type Props = Pick<UseData, 'clear' | 'setAddressLookup'> & {
  entityId: number
  entityType?: ENTITY_TYPES
  serviceLocationId?: number
  latitude?: number | null
  longitude?: number | null
}

export function useHandlers(props: Props) {
  const {
    clear,
    setAddressLookup,
    entityId,
    entityType,
    serviceLocationId,
    latitude,
    longitude,
  } = props
  const dispatch = useAppDispatch()

  const handleAddressClick = useCallback(
    (address: string) => {
      logger.log('[AddressMapLink] Click:', {
        address,
        entityId,
        entityType,
        latitude,
        longitude,
        serviceLocationId,
      })

      // Close any open popovers by dispatching a custom event
      window.dispatchEvent(new CustomEvent('closeAllPopovers'))

      // Set address lookup first to trigger marker creation
      setAddressLookup(address)

      // Set the map center and zoom in Redux if coordinates are available
      if (latitude != null && longitude != null) {
        logger.log('[AddressMapLink] Setting map center in Redux:', {
          lat: latitude,
          lng: longitude,
          zoom: 18,
        })
        dispatch(
          setMapViewDialogOpen({
            open: true,
            center: { lat: latitude, lng: longitude },
            zoom: 18,
            source: 'addressLink',
          }),
        )
      }
    },
    [
      dispatch,
      entityId,
      entityType,
      latitude,
      longitude,
      serviceLocationId,
      setAddressLookup,
    ],
  )

  const handleCloseDialogClick = useCallback(() => {
    dispatch(setMapViewDialogOpen({ open: false }))
    clear()
  }, [dispatch, clear])

  return {
    handleAddressClick,
    handleCloseDialogClick,
  }
}
